import React, { useEffect, useState } from "react";
import Checkbox from "components/Input/Checkbox";
import "assets/css/CheckboxGroup.min.css";

/**
 * @param viewType {checkbox, button}
 */

const CheckboxGroup = ({
  options,
  onChange,
  grouptheme = undefined,
  theme,
  title,
  defaultValue,
  viewType = "checkbox",
  className,
  showValidationState,
  validationState,
}) => {
  const [defaultValueState, setDefaultValueState] = useState(defaultValue);

  const [renderCount, setRenderCount] = useState(0);

  const [groupValues, setGroupValues] = useState([]);

  const themes = {
    light: "light",
    dark: "dark",
  };

  const getTheme = () => {
    if (themes.hasOwnProperty(grouptheme)) {
      const actTheme = ` ${themes[grouptheme].join(" ")}`;
      return actTheme;
    }
    return ` default`;
  };

  useEffect(() => {
    if (onChange && typeof onChange === "function") {
      onChange({ value: groupValues });
    }
  }, [groupValues]);

  const handleCheckboxChange = (value, checked) => {
    //! ITT NEM JÓ VALAMI
    if (checked) {
      setGroupValues((prev) => [...prev, value]);
    }

    if (!checked) {
      setGroupValues((prev) => [...prev].filter((item) => item !== value));
    }
  };

  const reset = () => {
    setDefaultValueState({ value: [] });
    setGroupValues([]);
    setRenderCount(renderCount + 1);
  };

  return (
    <>
      <div
        className={`${
          viewType === "button" ? "miniButtonGroup" : "CheckboxGroup"
        }${className ? ` ${className}` : ""}${
          showValidationState ? ` showValidationState` : ""
        }${!validationState ? ` error` : ""}${theme ? getTheme() : ""}`}
      >
        {title && (
          <div className="groupTitle">
            {groupValues?.length > 0 && (
              <div className="deleteContainer" onClick={() => reset()}>
                <i className="fas fa-times"></i>
              </div>
            )}
            <span className="title">{title}</span>
          </div>
        )}

        {options.map((curr, index) => (
          <Checkbox
            theme={theme}
            value={curr.value}
            label={curr.label}
            viewType={viewType}
            defaultValue={defaultValueState?.value.includes(curr?.value)}
            onChange={handleCheckboxChange}
            showValidationState={showValidationState}
            validationState={validationState}
            key={`Checkbox-${index}-${renderCount}`}
          />
        ))}
      </div>
    </>
  );
};

export default CheckboxGroup;
